import {Injectable} from '@angular/core';
import {checkIfValidURL} from '../url-validator.directive';
import {RdapServer} from '@iana-rzms/bff-sdk';
import {checkIfASCII} from '../../util/CommonFunctions';

@Injectable()
export class RdapServersValidatorService {

  constructor() {
  }

  validateRdapServers(newRdapServer: RdapServer, modifiedRDAPServers: Array<RdapServer>): string[] {
    let rdapErrors: string[] = [];
    if (!checkIfASCII(newRdapServer.url)) {
      rdapErrors.push("Invalid URL, URL cannot contain non-ASCII characters");
    }

    if (!checkIfValidURL(newRdapServer.url)) {
      rdapErrors.push("Invalid URL");
    }

    modifiedRDAPServers.forEach(rdap => {
      if(rdap.url === newRdapServer.url){
        rdapErrors.push("Duplicate RDAP Server");
      }
    });

    return rdapErrors;
  }
}
